import React, { useEffect } from "react";
import {
  Badge,
  Button,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import Switch from "@mui/material/Switch";
import { getDateFormat } from "../../utils/helpers";
import PropTypes from "prop-types";

const CalendarCom = ({
  handleClosePopover,
  item,
  handleChange,
  handleCancelled,
  props,
  handleEdit,
  popoverEvent,
}) => {

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://addevent.com/libs/atc/1.6.1/atc.min.js";
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);

    return () => {
      script.remove(); // ✅ SAFE & CORRECT
    };
  }, []);

  const isCreator = props?.userInfo?.id === item?.creator_id;

  const status = item?.mStatus;

  const isCancelled = status === "Cancelled";

  const creatorAllowedStatuses = [
    "Created",
    "Rescheduled",
    "Accepted",
    "Requested_For_Reschedule",
  ];

  const receiverAllowedStatuses = [
    "Created",
    "Rescheduled",
    "Accepted",
  ];

  const canCreatorAct = creatorAllowedStatuses.includes(status);
  const canReceiverAct = receiverAllowedStatuses.includes(status);

  const showCreatorActions = isCreator && canCreatorAct;
  const showReceiverActions = !isCreator && !isCancelled && canReceiverAct;

  const canReschedule = !isCancelled;
  const canAccept = status !== "Accepted";


  return (
    <Modal show={popoverEvent} onHide={handleClosePopover} size="xl" centered className="calendar-modal">
      <Modal.Header closeButton>
        <Modal.Title>{item?.subject}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped responsive className="welcome-table">
          <tbody>
            <tr>
              <td width="50%">
                <strong>Creator Name </strong>
              </td>
              <td width="50%">{item?.creator_name}</td>
            </tr>

            <tr>
              <td width="50%">
                <strong>Receiver Name </strong>
              </td>
              <td width="50%">{item?.receiver_name}</td>
            </tr>
            <tr>
              <td width="50%">
                <strong>Topic</strong>
              </td>
              <td width="50%">{item?.subject}</td>
            </tr>

            <tr>
              <td width="50%">
                <strong>Description </strong>
              </td>
              <td width="50%">{item?.description}</td>
            </tr>
            <tr>
              <td width="50%">
                <strong>
                  Receiver - Meeting Start Date/Time (
                  {Intl.DateTimeFormat()?.resolvedOptions()?.timeZone})
                </strong>
              </td>
              <td width="50%">
                {getDateFormat(
                  item?.meeting_start_datetime,
                  "YYYY-MM-DD hh:mm A"
                )}
              </td>
            </tr>

            <tr>
              <td width="50%">
                <strong>
                  Creator - Meeting Start Date/Time ({item?.meeting_timezone})
                </strong>
              </td>
              <td width="50%">{getDateFormat(item?.meeting_start_datetime_converted, "YYYY-MM-DD hh:mm A")}</td>
            </tr>
            <tr>
              <td width="50%">
                <strong>Duration</strong>
              </td>
              <td width="50%">{item?.meeting_end_datetime} hours</td>
            </tr>
            {item?.mStatus == "Accepted" && (
              <tr>
                <td width="50%">
                  <strong>Join Status</strong>
                </td>
                <td>
                  <Switch
                    checked={(() => {
                      const isCreator = props?.userInfo?.id === item?.creator_id;
                      const status = isCreator
                        ? item?.join_status_creator
                        : item?.join_status_receiver;

                      return status !== "No" && status !== "";
                    })()}
                    onChange={(e) => handleChange(e, item, "calendar")}
                    name="status"
                    color="primary"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                </td>

              </tr>
            )}

            <tr>
              <td width="50%">
                <strong>Status</strong>
              </td>
              {/* <td>
                <h5>
                  {item?.mStatus == "Created" && (
                    <Badge variant="primary">{item?.mStatus}</Badge>
                  )}
                  {item?.mStatus == "Accepted" && (
                    <Badge variant="success">{item?.mStatus}</Badge>
                  )}
                  {item?.mStatus == "Rejected" && (
                    <Badge variant="danger">{item?.mStatus}</Badge>
                  )}
                  {item?.mStatus == "Rescheduled" && (
                    <Badge variant="warning">{item?.mStatus}</Badge>
                  )}
                  {item?.mStatus == "Cancelled" && (
                    <Badge variant="danger">{item?.mStatus}</Badge>
                  )}
                  {item?.mStatus === "Requested_For_Reschedule" && (
                    <Badge variant="warning">
                      {item?.mStatus.replace(/_/g, " ")}
                    </Badge>
                  )}
                </h5>
              </td> */}

              {/* <td>
                <button type="button" className="status-btn">
                  {item?.mStatus === "Requested_For_Reschedule"
                    ? item?.mStatus?.replaceAll("_", " ")
                    : item?.mStatus}
                </button>
              </td> */}

              <td>
                {/* <h5> */}
                  {item.mStatus == "Created" && (
                    <Badge variant="primary">
                      {item?.mStatus}
                    </Badge>
                  )}
                  {item.mStatus == "Accepted" && (
                    <Badge bg="success" className="badge badge-success">
                      {item?.mStatus}
                    </Badge>
                  )}
                  {item.mStatus == "Rejected" && (
                    <Badge variant="danger">
                      {item?.mStatus}
                    </Badge>
                  )}
                  {item.mStatus == "Rescheduled" && (
                    <Badge bg="warning" className="badge badge-warning">
                      {item?.mStatus}
                    </Badge>
                  )}
                  {item.mStatus == "Cancelled" && (
                    <Badge variant="danger">
                      {item?.mStatus}
                    </Badge>
                  )}
                  {item.mStatus === "Requested_For_Reschedule" && (
                    <Badge bg="warning" className="badge badge-warning">
                      {item.mStatus.replaceAll("_", " ")}
                    </Badge>
                  )}
                {/* </h5> */}
              </td>

            </tr>
            {item?.mStatus == "Rescheduled" ||
              item?.mStatus == "Requested_For_Reschedule" ||
              item?.mStatus == "Rejected" ||
              item?.mStatus == "Cancelled" ? (
              <tr>
                <td width="50%">
                  <strong>Reason</strong>
                </td>
                <td>
                  {(item?.mStatus == "Rescheduled" ||
                    item?.mStatus == "Requested_For_Reschedule") && (
                      <>
                        {item?.reason_of_rescheduling
                          ? item?.reason_of_rescheduling
                          : "N/A"}
                      </>
                    )}
                  {item?.mStatus == "Rejected" && (
                    <>
                      {item?.reason_of_rejection
                        ? item?.reason_of_rejection
                        : "N/A"}
                    </>
                  )}
                  {item?.mStatus == "Cancelled" && (
                    <>
                      {item?.reason_of_cancellation
                        ? item?.reason_of_cancellation
                        : "N/A"}
                    </>
                  )}
                </td>
              </tr>
            ) : (
              ""
            )}
            <tr>
              <td>
                <strong>Action</strong>
              </td>
              <td scope="row">
                {/* CREATOR ACTIONS */}
                {showCreatorActions && (
                  <>
                    {canReschedule && (
                      <button
                        className="btn btn_red py-1 px-2 me-2"
                        onClick={() => handleEdit(item, true, "calendar")}
                      >
                        <OverlayTrigger overlay={<Tooltip>Reschedule</Tooltip>}>
                          <i className="fas fa-edit mr-0"></i>
                        </OverlayTrigger>
                      </button>
                    )}

                    {canReschedule ? (
                      <button
                        className="btn btn_red py-1 px-2"
                        onClick={() => handleCancelled(item, "Cancelled", "calendar")}
                      >
                        <OverlayTrigger overlay={<Tooltip>Cancel</Tooltip>}>
                          <i className="fa fa-ban mr-0"></i>
                        </OverlayTrigger>
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </>
                )}

                {/* RECEIVER ACTIONS */}
                {showReceiverActions && (
                  <>
                    {canAccept && (
                      <Button
                        variant="success py-1 px-2 me-2"
                        onClick={() => handleCancelled(item, "Accepted", "calendar")}
                      >
                        <OverlayTrigger overlay={<Tooltip>Accept</Tooltip>}>
                          <i className="fa fa-thumbs-up mr-0"></i>
                        </OverlayTrigger>
                      </Button>
                    )}

                    <Button
                      variant="danger py-1 px-2 me-2"
                      onClick={() => handleCancelled(item, "Rejected", "calendar")}
                    >
                      <OverlayTrigger overlay={<Tooltip>Reject</Tooltip>}>
                        <i className="fa fa-thumbs-down mr-0"></i>
                      </OverlayTrigger>
                    </Button>

                    <Button
                      variant="danger py-1 px-2"
                      onClick={() =>
                        handleCancelled(item, "Requested_For_Reschedule", "calendar")
                      }
                    >
                      <OverlayTrigger overlay={<Tooltip>Request For Reschedule</Tooltip>}>
                        <i className="fa fa-paper-plane mr-0"></i>
                      </OverlayTrigger>
                    </Button>
                  </>
                )}

                {/* FALLBACK */}
                {!showCreatorActions && !showReceiverActions && "N/A"}
              </td>

            </tr>
            {item?.mStatus != "Cancelled" &&
              item?.mStatus != "Rejected" &&
              item?.mStatus == "Accepted" && (
                <tr>
                  <td>
                    <strong>Add to Calendar</strong>
                  </td>
                  <td>
                    <div className="addeventatc mt-3">
                      <i className="fa fa-plus"></i>{" "}
                      Calendar
                      <span className="start">{item?.web_start_date}</span>
                      <span className="end">
                        {item?.web_end_date || item?.web_start_date}
                      </span>
                      <span className="timezone">{item?.meeting_timezone}</span>
                      <span className="title">{item?.subject}</span>
                      <span className="description">{item?.description}</span>
                    </div>
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

CalendarCom.propTypes = {
  handleClosePopover: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subject: PropTypes.string,
    creator_name: PropTypes.string,
    receiver_name: PropTypes.string,
    description: PropTypes.string,
    meeting_start_datetime: PropTypes.string,
    meeting_start_datetime_converted: PropTypes.string,
    meeting_end_datetime: PropTypes.string,
    meeting_timezone: PropTypes.string,
    mStatus: PropTypes.string,
    reason_of_rescheduling: PropTypes.string,
    reason_of_rejection: PropTypes.string,
    reason_of_cancellation: PropTypes.string,
    join_status_creator: PropTypes.string,
    join_status_receiver: PropTypes.string,
    creator_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    web_start_date: PropTypes.string,
    web_end_date: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleCancelled: PropTypes.func.isRequired,
  props: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  popoverEvent: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default CalendarCom;
